var _rect, _rect2, _rect3, _rect4, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 16,
    height: 9,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 4,
    height: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 6,
    height: 7,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 4,
    height: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4567 24.479C27.7257 26.0466 25.6781 27.224 23.4524 27.9314C21.2268 28.6387 18.8752 28.8596 16.5567 28.579C9.05674 27.779 1.25674 21.879 2.05674 14.379C2.35674 11.079 2.45671 12.279 2.95671 4.67901C2.95671 4.27901 4.05674 4.07902 4.05674 4.07902C4.05674 4.07902 5.85673 3.67901 5.85673 4.67901C5.85567 6.48379 6.15999 8.27575 6.75676 9.97901C7.86296 13.2404 9.9619 16.0739 12.7594 18.0824C15.557 20.0909 18.9129 21.1737 22.3567 21.179C24.0168 21.2062 25.6707 20.97 27.2568 20.479C27.7778 20.2711 28.3569 20.2609 28.885 20.4502C29.4131 20.6395 29.8538 21.0153 30.1242 21.5069C30.3946 21.9985 30.4759 22.5719 30.353 23.1193C30.2301 23.6667 29.9113 24.1502 29.4567 24.479Z",
    fill: "url(#paint0_linear_20_220)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55664 8.979C8.45607 11.0653 10.8645 12.6229 13.5464 13.4993C16.2283 14.3758 19.0917 14.541 21.8566 13.979C23.5045 13.6686 25.0915 13.0946 26.5566 12.279C27.0167 12.0472 27.5412 11.9765 28.0461 12.0783C28.5511 12.1801 29.0073 12.4485 29.3416 12.8404C29.6758 13.2323 29.8689 13.7251 29.8898 14.2398C29.9106 14.7545 29.7581 15.2613 29.4566 15.679L27.9566 17.379",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_220",
    x1: 30.4089,
    y1: 28.6971,
    x2: 5.95194,
    y2: 0.564409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanana);
export default __webpack_public_path__ + "static/media/banana.da3e0082b2be9cbae1d83ae561f51c56.svg";
export { ForwardRef as ReactComponent };